import { render, staticRenderFns } from "./introducePageFour.vue?vue&type=template&id=bc5ceba0&scoped=true"
import script from "./introducePageFour.vue?vue&type=script&lang=js"
export * from "./introducePageFour.vue?vue&type=script&lang=js"
import style0 from "./introducePageFour.vue?vue&type=style&index=0&id=bc5ceba0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5ceba0",
  null
  
)

export default component.exports